import React,{useState} from "react";
import { PortfolioModal, PortfolioTabs } from "../../SecondComponents";

const Portfolio = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [imgUrl,setImgUrl] = useState()
    const { selectedLanguage } = props;
    const showModal = (imgUrl) => {
        setImgUrl(imgUrl)
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (
        <div className="main">
            <div className="second-design-service-container">
                <div className="service-top-div">
                    <div>
                        <h1>{selectedLanguage?.txt_portfolio} – {selectedLanguage?.txt_modern_title}</h1>
                    </div>
                </div>
                <div className="modern-title-container">
                    <PortfolioTabs {...props} showModal={showModal}/>
                </div>
            </div>
            <PortfolioModal isModalOpen={isModalOpen} showModal={showModal} setIsModalOpen={setIsModalOpen} handleOk={handleOk} handleCancel={handleCancel} imgUrl={imgUrl}/>
        </div>
    )
}

export default Portfolio